import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, concatMap, withLatestFrom } from 'rxjs/operators';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';
import AppState from '../../state';
import { NoOp, OpenMenu } from '../../ui/action-creators';
import { SetPopupNotification } from '../action-creators';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '@webapp/utils/localstorage';
import { SyncBrief } from '@services/sync-license/types/sync-brief';

export const showLatestSyncNotificationEpic = (
  action$: Observable<LocationChangeAction>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<LocationChangeAction>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(([, state]) => state.notifications.notificationLoaded),
    concatMap(([action, state]) => {
      const syncNotifications = state.notifications.items.filter(
        (n) => n.templateName === 'sync-opportunity' && n.createdAt
      );
      if (!syncNotifications.length) {
        return [new NoOp()];
      }
      const syncNotificationPayload = syncNotifications.reduce((a, b) =>
        new Date(a.createdAt) > new Date(b.createdAt) ? a : b
      ).payload as SyncBrief;

      if (
        action.payload.location.pathname.startsWith('/dashboard') &&
        !getLocalStorageItem(
          `syncNotificationShown-${syncNotificationPayload.id}`
        ) &&
        !state.ui.menuOpened &&
        syncNotificationPayload &&
        syncNotificationPayload.submission_deadline &&
        new Date(syncNotificationPayload.submission_deadline) > new Date()
      ) {
        setLocalStorageItem(
          `syncNotificationShown-${syncNotificationPayload.id}`,
          true
        );
        return [
          new SetPopupNotification(syncNotificationPayload),
          new OpenMenu('SYNC_NOTIFICATION_MENU'),
        ];
      }

      return [new NoOp()];
    })
  );
